<template>
  <div id="globalOverlay">
    <overlay-content
        v-for="target in targets" 
        :columns="1" 
        :target="target"
        :key="target.key">
    </overlay-content>
  </div>
</template>

<style lang="scss">
  @import "../../../styles/scss/global/overlay";
  @import "../../../styles/scss/component/overlay/link";
</style>

<script>
import OverlayContent from "./Content";
export default {
  components: { OverlayContent },
  computed: {
    targets() {
      return this.$root.targets;
    }
  }
};
</script>